export const AppPageLeanHeaderDataHooks = {
  APP_NAME: 'app-page-lean-header-app-name',
  HEADER_LOGOS: 'app-page-lean-header-logos',
  CONTAINER: 'app-page-lean-header-container',
  WIX_LOGO: 'app-page-lean-header-wix-logo',
  LOGO_IMAGE: 'app-page-lean-header-logo-image',
  REVIEWS_INFO: 'app-page-lean-header-reviews-info',
  APP_NAME_AND_BADGES: 'app-page-lean-header-app-name-and-badges',
};
